import styled from 'styled-components';
import { tabletPortraitMinWidth, textGrey, tilePadding } from '../cssConstants';

export const NoPaddingTile = styled.section<{ $disabled?: boolean }>`
	margin-bottom: 10px;
	width: 100%;
	background-color: white;
	border-radius: 10px;
	color: ${textGrey};
	opacity: ${(props) => (props.$disabled ? 0.8 : 1)};
`;

const Tile = styled(NoPaddingTile)`
	padding: ${tilePadding};
`;

export default Tile;

export const TileTitle = styled.h2`
	font-size: 14px;
	line-height: 16px;
	color: ${(props) => props.theme.brandingColourHeavy};
	margin: 0 0 7px 0;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 18px;
		line-height: 21px;
	}
`;

export const LargeTileTitle = styled(TileTitle)`
	font-size: 16px;
	line-height: 19px;
	margin: 10px 0 0 0;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 24px;
		line-height: 28px;
	}
`;

export const LargeCenteredTileTitle = styled(LargeTileTitle)`
	text-align: center;
`;

// TODO: Consider replacing all other Paragraph with this TileParagraph
export const TileParagraph = styled.p`
	text-align: left;
	color: ${textGrey};
	font-size: 14px;
	line-height: 20px;
	margin-top: 6px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		text-align: left;
		font-size: 18px;
		line-height: 24px;
	}
`;
